export default class DropdownInputItem {
    constructor(
        public value: string,
        public text: string
    ) {
    }
}
